import { WidgetsLimitConfigMain } from '@/widgets/limit-config';

export const PagesLimitConfigMain = () => <WidgetsLimitConfigMain />;
